import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  ViewChild,
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Payment } from "../../../../models/offer.model";
import { OfferCalculatorService } from "../../../../services/offer-calculator.service";
import { PaymentScheduleExportService } from "../../../../services/payment-schedule-export.service";
import { ApplicationOffer } from "../../../../../application/application.model";
import { ProductCode } from "../../../../../product/product.model";
import { MessageService } from "../../../../../../core/message/message.service";
import { getPaymentScheduleExportColumns } from "./payment-schedule-columns";

@Component({
    selector: "ifc-offer-payment-schedule-table",
    templateUrl: "./offer-payment-schedule-table.component.html",
    styleUrls: ["./offer-payment-schedule-table.component.scss"],
    standalone: false
})
export class OfferPaymentScheduleTableComponent
  implements OnChanges, AfterViewInit
{
  @Input() offerDetail: ApplicationOffer;
  @Input() sampleDraw: number;
  @Input() isPublicView: boolean;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  dataSource = new MatTableDataSource<Payment>();
  displayedColumns: string[] = [];
  productCode = ProductCode;
  isExporting = false;

  constructor(
    private offerCalculatorService: OfferCalculatorService,
    private readonly exportService: PaymentScheduleExportService,
    private readonly messageService: MessageService
  ) {}

  ngOnChanges(): void {
    this.calculatePayments();
    this.setTableDetails();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  calculatePayments(): void {
    let payments: Payment[];
    if (this.offerDetail.productCode == ProductCode.Term)
      payments = this.offerCalculatorService.getTermLoanPayments(this.offerDetail, null, this.sampleDraw);
    else if (
      this.offerDetail.productCode == ProductCode.LOC ||
      this.offerDetail.productCode == ProductCode.Law
    )
      payments = this.offerCalculatorService.getLineOfCreditLoanPayments(
        this.offerDetail,
        this.sampleDraw
      );

    this.dataSource = new MatTableDataSource(payments);

    if (this.paginator) {
      this.paginator.firstPage();
      this.paginator.pageSize = 10;
      this.dataSource.paginator = this.paginator;
    }
  }

  export(): void {
    if (this.isExporting) {
      return;
    }
    this.isExporting = true;

    setTimeout(() => {
      try {
        const columns = getPaymentScheduleExportColumns(
          this.offerDetail?.productCode,
          this.isPublicView
        );
        this.exportService.export(this.dataSource.data, columns, this.isPublicView);
      } catch (error) {
        console.error(error);
        this.messageService.error("Unable to export the payment schedule. Please try again.");
      } finally {
        this.isExporting = false;
      }
    });
  }

  private setTableDetails() {
    const baseColumns = [
      "date",
      "amount",
      "principalAmount",
      "interestAmount",
      "balance",
      "totalInterestCost",
      "capitalRepayment",
      "totalPayback",
    ];
    if (this.offerDetail?.productCode === ProductCode.Term) {
      this.displayedColumns = [...baseColumns, 'payoff'];
    } else {
      this.displayedColumns = baseColumns;
    }
  }
}
